import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/dashboard/Dashboard';
import CustomerList from './pages/customers/CustomerList';
import VehicleList from './pages/vehicles/VehicleList';
import ServiceList from './pages/services/ServiceList';
import AppointmentCalendar from './pages/appointments/AppointmentCalendar';
import OrderList from './pages/orders/OrderList';
import OrderDetail from './pages/orders/OrderDetail';
import FinancialPage from './pages/financial/FinancialPage';
import StockPage from './pages/stock/StockPage';
import EmployeePage from './pages/employees/EmployeePage';
import ReportPage from './pages/reports/ReportPage';
import LandingEditor from './pages/landing/LandingEditor';
import SettingsPage from './pages/settings/SettingsPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTenants from './pages/admin/AdminTenants';
import AdminPlans from './pages/admin/AdminPlans';
import AdminCoupons from './pages/admin/AdminCoupons';
import AdminTools from './pages/admin/AdminTools';
import AdminSettings from './pages/admin/AdminSettings';
import Billing from './pages/billing/Billing';
import UsersPage from './pages/users/UsersPage';

function SmartRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user?.role === 'super_admin' ? '/admin' : '/dashboard'} replace />;
}

function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh' }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ fontSize:'2rem',marginBottom:8 }}>🚗</div>
        <div style={{ color:'#2563EB',fontWeight:700 }}>AutoFlow</div>
        <div style={{ fontSize:'.85rem',color:'#6B7280',marginTop:4 }}>Carregando...</div>
      </div>
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'super_admin') return <Navigate to="/dashboard" replace />;

  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"    element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route path="/dashboard"    element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/appointments" element={<PrivateRoute><AppointmentCalendar /></PrivateRoute>} />
      <Route path="/orders"       element={<PrivateRoute><OrderList /></PrivateRoute>} />
      <Route path="/orders/:id"   element={<PrivateRoute><OrderDetail /></PrivateRoute>} />
      <Route path="/customers"    element={<PrivateRoute><CustomerList /></PrivateRoute>} />
      <Route path="/vehicles"     element={<PrivateRoute><VehicleList /></PrivateRoute>} />
      <Route path="/services"     element={<PrivateRoute><ServiceList /></PrivateRoute>} />
      <Route path="/financial"    element={<PrivateRoute><FinancialPage /></PrivateRoute>} />
      <Route path="/stock"        element={<PrivateRoute><StockPage /></PrivateRoute>} />
      <Route path="/employees"    element={<PrivateRoute><EmployeePage /></PrivateRoute>} />
      <Route path="/reports"      element={<PrivateRoute><ReportPage /></PrivateRoute>} />
      <Route path="/landing"       element={<PrivateRoute><LandingEditor /></PrivateRoute>} />
      <Route path="/billing"       element={<PrivateRoute><Billing /></PrivateRoute>} />
      <Route path="/users"         element={<PrivateRoute><UsersPage /></PrivateRoute>} />
      <Route path="/settings"     element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
      <Route path="/admin"           element={<PrivateRoute adminOnly><AdminDashboard /></PrivateRoute>} />
      <Route path="/admin/tenants"   element={<PrivateRoute adminOnly><AdminTenants /></PrivateRoute>} />
      <Route path="/admin/plans"     element={<PrivateRoute adminOnly><AdminPlans /></PrivateRoute>} />
      <Route path="/admin/coupons"   element={<PrivateRoute adminOnly><AdminCoupons /></PrivateRoute>} />
      <Route path="/admin/settings"  element={<PrivateRoute adminOnly><AdminSettings /></PrivateRoute>} />
      <Route path="/admin/tools"    element={<PrivateRoute adminOnly><AdminTools /></PrivateRoute>} />
      <Route path="*" element={<SmartRedirect />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter basename="/panel">
      <AuthProvider>
        <Toaster position="top-right" />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
